import React, { useState, useEffect } from "react";
import {
  Modal,
  Input,
  Select,
  Switch,
  Button,
} from "../ui";
import {
  createPincodeRate,
  updatePincodeRate,
  createPincodeRatePortal,
  updatePincodeRatePortal,
} from "../../api/transport/transportApi";
import { useToast } from "../../context/ToastContext";

const VEHICLE_TYPE_OPTIONS = [
  { label: "Bus", value: "BUS" },
  { label: "Van", value: "VAN" },
  { label: "Mini Bus", value: "MINI_BUS" },
  { label: "Other", value: "OTHER" },
];

const PincodeRateModal = ({
  isOpen,
  onClose,
  onSuccess,
  editData = null,
  isPortal = false,
}) => {
  const [form, setForm] = useState({
    pincode: "",
    areaName: "",
    vehicleType: "BUS",
    monthlyCharge: "",
    description: "",
    isActive: true,
  });
  const [loading, setLoading] = useState(false);
  const toast = useToast();

  useEffect(() => {
    if (!isOpen) return;
    if (editData) {
      setForm({
        pincode: editData.pincode || "",
        areaName: editData.areaName || "",
        vehicleType: editData.vehicleType || "BUS",
        monthlyCharge: editData.monthlyCharge ?? "",
        description: editData.description || "",
        isActive: editData.isActive !== false,
      });
    } else {
      setForm({
        pincode: "",
        areaName: "",
        vehicleType: "BUS",
        monthlyCharge: "",
        description: "",
        isActive: true,
      });
    }
  }, [isOpen, editData]);

  const handleSubmit = async (e) => {
    e?.preventDefault?.();
    setLoading(true);
    try {
      const payload = {
        pincode: form.pincode.trim(),
        areaName: form.areaName.trim(),
        vehicleType: form.vehicleType,
        monthlyCharge: Number(form.monthlyCharge),
        description: form.description,
        isActive: form.isActive,
      };
      if (editData?._id) {
        if (isPortal) await updatePincodeRatePortal(editData._id, payload);
        else await updatePincodeRate(editData._id, payload);
      } else {
        if (isPortal) await createPincodeRatePortal(payload);
        else await createPincodeRate(payload);
      }
      onSuccess?.();
      onClose?.();
    } catch (err) {
      toast.error(err.response?.data?.message || "Failed to save pincode rate");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={editData ? "Edit Pincode Rate" : "Add Pincode Rate"}
      footer={
        <>
          <Button variant="secondary" onClick={onClose} disabled={loading}>
            Cancel
          </Button>
          <Button onClick={handleSubmit} isLoading={loading}>
            {editData ? "Update" : "Create"}
          </Button>
        </>
      }
    >
      <form onSubmit={handleSubmit} className="space-y-4">
        
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <Input
            label="Pincode"
            placeholder="e.g. 110001"
            value={form.pincode}
            onChange={(e) => setForm((p) => ({ ...p, pincode: e.target.value }))}
            required
          />
          <Input
            label="Area name"
            placeholder="Optional area / locality"
            value={form.areaName}
            onChange={(e) => setForm((p) => ({ ...p, areaName: e.target.value }))}
          />
        </div>
        <Select
          label="Vehicle type"
          options={VEHICLE_TYPE_OPTIONS}
          value={form.vehicleType}
          onChange={(v) => setForm((p) => ({ ...p, vehicleType: v }))}
        />
        <Input
          label="Monthly charge (₹)"
          type="number"
          min={0}
          step="0.01"
          placeholder="0.00"
          value={form.monthlyCharge}
          onChange={(e) => setForm((p) => ({ ...p, monthlyCharge: e.target.value }))}
          required
        />
        <Input
          label="Description"
          placeholder="Optional notes"
          value={form.description}
          onChange={(e) => setForm((p) => ({ ...p, description: e.target.value }))}
        />
        <Switch
          label="Active"
          checked={form.isActive}
          onChange={(checked) => setForm((p) => ({ ...p, isActive: checked }))}
        />
      </form>
    </Modal>
  );
};

export default PincodeRateModal;
